"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var locales_1 = require("../locales");
var getPreviewTemplate = function (operator, attribute) {
    switch (operator) {
        case "TOP":
            return attribute ? locales_1.messages.topWithAttr.id : locales_1.messages.topWithoutAttr.id;
        case "BOTTOM":
            return attribute ? locales_1.messages.bottomWithAttr.id : locales_1.messages.bottomWithoutAttr.id;
        default:
            throw new Error("Operator '" + operator + "' is not supported!");
    }
};
exports.Preview = function (_a) {
    var operator = _a.operator, value = _a.value, measure = _a.measure, attribute = _a.attribute;
    return (react_1.default.createElement("div", { className: "gd-rf-preview s-rf-preview" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: getPreviewTemplate(operator, attribute), tagName: "span", values: {
                measure: measure.title,
                attribute: attribute === null || attribute === void 0 ? void 0 : attribute.title,
                operator: operator,
                value: value,
                strong: function (chunks) { return react_1.default.createElement("strong", null, chunks); },
            } })));
};
//# sourceMappingURL=Preview.js.map